export default "__VITE_ASSET__e0a552e5__"